import React, { Dispatch } from 'react'

import './Header.scss'
import { connect } from 'react-redux'
import {
  IReduxAction,
  IReduxState,
  ResultDisplayMode
} from '../../utils/ReduxStore'

import './ShowResultsButton.scss'
import DropdownSelect from '../Helpers/DropdownSelect'

interface IDispatchProps {
  reset: () => void
  setResultDisplayMode: (resultDisplayMode: ResultDisplayMode) => void
}

interface IStateProps {
  resultDisplayMode: ResultDisplayMode
}

interface IProps extends IDispatchProps, IStateProps {}

class ShowResultsButton extends React.Component<IProps> {
  public constructor(props: IProps) {
    super(props)

    this.changeResultDisplayMode = this.changeResultDisplayMode.bind(this)
  }

  protected changeResultDisplayMode(
    resultDisplayMode: ResultDisplayMode
  ): void {
    this.props.setResultDisplayMode(resultDisplayMode)
  }

  public render(): JSX.Element {
    return (
      <DropdownSelect
        id="ShowResultsButton"
        className="ShowResultsButton ml-2"
        selectedItemId={this.props.resultDisplayMode}
        onChange={(id: string): void => {
          this.props.setResultDisplayMode(id as ResultDisplayMode)
        }}
        items={[
          {
            id: 'geographicalMap',
            icon: 'fas fa-map-marked',
            children: 'Map results'
          },
          // {
          //   id: 'legislature',
          //   icon: 'fas fa-school',
          //   children: 'Legislature results'
          // },
          {
            id: 'tables',
            icon: 'fas fa-table',
            children: 'Tabular results'
          },
          {
            id: 'insights',
            icon: 'fas fa-analytics',
            children: 'Insights'
          }
        ]}
      />
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  resultDisplayMode: state.resultDisplayMode
})

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  reset: (): void => {
    dispatch({ type: 'RESET' })
  },
  setResultDisplayMode: (resultDisplayMode: ResultDisplayMode): void => {
    dispatch({ type: 'SET_RESULT_DISPLAY_MODE', resultDisplayMode })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowResultsButton)
